//import axios from 'axios';
import axios from '../utils/axios';
const API_URL = process.env.REACT_APP_API_URL + "/v1/admin/";


const getAllEcxSurveys = (clinicid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/ecx-surveys")
}

const saveEcxSurvey = (clinicid,data)=>{
    return axios.post(API_URL+"clinics/"+clinicid+"/ecx-surveys",data)
}
const updateEcxSurvey = (clinicid,surveyid,data)=>{
    return axios.put(API_URL+"clinics/"+clinicid+"/ecx-surveys/"+surveyid,data)
}
const getEcxSurveyById = (clinicid,surveyid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/ecx-surveys/"+surveyid)
}
const deleteEcxSurvey = (clinicid,surveyid)=>{
    return axios.delete(API_URL+"clinics/"+clinicid+"/ecx-surveys/"+surveyid)
}

//Clinic Surveys from Admin
const getAllSurveys = (clinicid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/surveys")
}

const getSurveyById = (clinicid,surveyid)=>{
    return axios.get(API_URL+"clinics/"+clinicid+"/surveys/"+surveyid)
}

export default {
    getAllEcxSurveys,
    saveEcxSurvey,
    updateEcxSurvey,
    getEcxSurveyById,
    deleteEcxSurvey,
    getAllSurveys,
    getSurveyById
}